import React, { useState, useEffect } from 'react';
import AppSelect from '@nxsys/components/AppSelect';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { PayFrequencySelectProps, PayFrequencyValue } from './type';
import { defaultPaymentFrequency } from '@nxsys/constants/AppConstants';

const AppPayFrequencySelect: React.FC<PayFrequencySelectProps> = ({
  value,
  onChange,
  initValue,
  className,
  placeholder,
  disabled = false,
  allowClear = true,
  onFilter,
}) => {
  const { messages } = useTypedIntl();

  const isControlled = value !== undefined;

  const [internalValue, setInternalValue] = useState<PayFrequencyValue>(() => {
    if (isControlled) return undefined;
    return initValue ?? undefined;
  });

  const currentValue = isControlled ? value : internalValue;

  const selectedOption = currentValue
    ? defaultPaymentFrequency.find((opt) => opt.value === currentValue)
    : undefined;

  useEffect(() => {
    if (!isControlled && initValue !== undefined) {
      setInternalValue(initValue);
    }
  }, [initValue, isControlled]);

  const handleChange = (
    option: { label: string; value: string } | undefined,
  ) => {
    const selectedValue = option?.value as PayFrequencyValue;

    if (!isControlled) {
      setInternalValue(selectedValue);
    }

    if (onChange) {
      onChange(selectedValue);
    }

    if (onFilter) {
      onFilter({ payFrequency: selectedValue });
    }
  };

  const handleClear = () => {
    if (!isControlled) {
      setInternalValue(undefined);
    }

    if (onChange) {
      onChange(undefined);
    }

    if (onFilter) {
      onFilter({ payFrequency: undefined });
    }
  };

  return (
    <div className={className}>
      <AppSelect
        placeholder={placeholder || messages['common.payFrequency']}
        allowClear={allowClear}
        value={selectedOption || undefined}
        onChange={handleChange}
        onClear={handleClear}
        disabled={disabled}
        options={defaultPaymentFrequency}
        className="min-w-[210px] lg:!min-w-[210px] sm:!w-full md:!w-full"
      />
    </div>
  );
};

export default AppPayFrequencySelect;
